export default "__VITE_ASSET__Dx8q$3L5__"